
// import { create } from 'apisauce'
import axios from 'axios'
// import {settings} from 'cluster'
/**
 * init class API
 * @param opt
 * @returns {SystemSettingApi}
 * @constructor
 */
function SystemSettingApi (opt) {
  if (!(this instanceof SystemSettingApi)) {
    return new SystemSettingApi(opt)
  }
  opt = opt || {}
  this.classVersion = '1.0.0'
  this.api = axios.create({
    baseURL: opt.url,
    timeout: 9000000
  })
}
// SystemSettingApi.localserver.com
/**
 * Request to the server,
 * You fixed: https://gist.github.com/pranavrajs/66bccee3f8ba100742a1273db6f587af
 * @param url
 * @param callback
 * @returns {axios.Promise}
 * @private
 */
SystemSettingApi.prototype.assignNewOptions = async function (opt) {
  // console.log("New option->", opt);
  this.url = opt
  this.createUpdateApi()
}
SystemSettingApi.prototype.createUpdateApi = async function () {
  // console.log(this.api, 'this.api')
  if (this.api == null) {
    // console.log("creating first time->", this.url);
    this.api = axios.create({
      baseURL: this.url,
      timeout: 20000
      // headers: {'Accept': 'application/vnd.github.v3+json'}
    })
    const naviMonitor = response => {}// console.log("hey!  listen! ", response);
    this.api.addMonitor(naviMonitor)
    // console.log("assigning base url-->", this.url);

    // this.api.addRequestTransform(request => {
    //   request.data.build = buildNumber;
    //   request.data.version = readableVersion;
    // })
  } else {
    this.api.defaults.baseURL = this.url
    console.log('assigning base url->', this.url)
    // this.api.setBaseURL(this.url);
  }
  // console.log("api->", this.api.getBaseURL());
}
SystemSettingApi.prototype._requestAuthPost = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Authorization': 'Bearer 23432567654',
    'Content-Type': contentType
  }
  console.log(headers)
  return this.api.post(url, data, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  })
}
SystemSettingApi.prototype._requestDataPost = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType
  }
  return this.api.post(url, data, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}
SystemSettingApi.prototype._requestDataPostFileAttachment = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType,
    responseType: 'blob'
  }
  return this.api.post(url, data, headers).then((response) => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}
SystemSettingApi.prototype._requestDataGet = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType
  }
  var param = ''
  if (data !== '') {
    param = '/' + data
  }
  console.log(param)
  return this.api.get(url + param, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}
SystemSettingApi.prototype._requestFileDataGet = function (url, contentType, data, callback) {
  var headers = {
    responseType: 'arraybuffer'
  }
  var param = ''
  if (data !== '') {
    param = '/' + data
  }
  return this.api.get(url + param, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}

SystemSettingApi.prototype.getGeneralData = async function (data, callback) {
  const requestUrl = 'api/v1/admin/general/data'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

SystemSettingApi.prototype.updateSystemSetting = async function (data, callback) {
  const requestUrl = 'api/v1/admin/general/updateData'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
SystemSettingApi.prototype.updateCompanyLogo = async function (data, callback) {
  const requestUrl = 'api/v1/admin/general/updateCompanyLogo'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
SystemSettingApi.prototype.GetCompanyLogo = async function (data, callback) {
  const requestUrl = 'api/v1/admin/general/getCompanyLogo'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
export default SystemSettingApi



// WEBPACK FOOTER //
// ./src/View/SystemSetting/SystemSettingApi/SystemSettingApi.js